




// import { useState, useEffect } from "react";
// import SearchComponent from "../../component/SearchComponent";
// import JobPostJobPage from "../../component/JobPostJobPage";
// import Header from "../../component/Header";
// import { useLocation, useNavigate } from "react-router-dom";
// import qs from "query-string";
// import { useFetchData } from "../../hooks/useFtechData";
// import { ALL_JOB } from "../../resources/resource";
// import Loader from "../../component/utilities/Loader";
// import { getFilteredJobs } from "./data";
// import Card from "./Crad";
// import JobSearchLoader from "../../component/utilities/JobSearchLoader";

// function JobPage() {
//   const [allJobs, setAllJobs] = useState([]);
//   const [filteredJobs, setFilteredJobs] = useState([]);
//   const [filterList, setFilterList] = useState([]);
//   const [mainSearchForm, setMainSearchForm] = useState({});
//   const [selectedLga, setSelectedLga] = useState(null);
//   const [selectedCity, setSelectedCity] = useState(null);
//   const [jobCounts, setJobCounts] = useState({ lgas: {}, cities: {} });
//   const location = useLocation();
//   const navigate = useNavigate();

//   const { jobTitle, workType, state, lga, city } = qs.parse(location.search);

//   const { data, loading, errors } = useFetchData(ALL_JOB);

//   // Extract unique Local Governments and Cities (only from Online jobs in the selected state)
//   const localGovernments = data
//     ? [...new Set(data.filter(job => job.state === state ).map(job => job.localGovernment))]
//     : [];
//   const cities = data
//     ? [...new Set(data.filter(job => job.state === state ).map(job => job.city))]
//     : [];

//   // Compute job counts for LGAs and cities (only Online jobs)
//   useEffect(() => {
//     if (data && state) {
//       const stateJobs = data.filter((job) => job.state === state );
//       const lgaCounts = stateJobs.reduce((acc, job) => {
//         if (job.localGovernment) acc[job.localGovernment] = (acc[job.localGovernment] || 0) + 1;
//         return acc;
//       }, {});
//       const cityCounts = stateJobs.reduce((acc, job) => {
//         if (job.city) acc[job.city] = (acc[job.city] || 0) + 1;
//         return acc;
//       }, {});
//       setJobCounts({ lgas: lgaCounts, cities: cityCounts });
//     } else {
//       setJobCounts({ lgas: {}, cities: {} });
//     }
//   }, [data, state]);

//   // Set allJobs and initial filteredJobs — ONLY Online jobs
//   useEffect(() => {
//     if (data) {
//       const onlineJobs = data;
//       setAllJobs(onlineJobs);

//       const initialFiltered = getFilteredJobs(onlineJobs, jobTitle, workType, state);
//       setFilteredJobs(initialFiltered);
//     }
//   }, [data, jobTitle, workType, state]);

//   // Sync selected LGA/City from URL and reapply filters
//   useEffect(() => {
//     if (lga) setSelectedLga(lga);
//     if (city) setSelectedCity(city);
//     applyFilters(allJobs, { jobTitle, workType, state, lga, city });
//   }, [lga, city, allJobs, jobTitle, workType, state]);

//   // Apply filters starting from allJobs (which are all Online)
//   const applyFilters = (jobs, filters) => {
//     let filteredResults = [...jobs]; // jobs === allJobs → all Online

//     if (filters.jobTitle) {
//       filteredResults = filteredResults.filter((job) =>
//         job.jobTitle.toLowerCase().includes(filters.jobTitle.toLowerCase())
//       );
//     }
//     if (filters.workType) {
//       filteredResults = filteredResults.filter(
//         (job) => job.workType.toLowerCase() === filters.workType.toLowerCase()
//       );
//     }
//     if (filters.state) {
//       filteredResults = filteredResults.filter(
//         (job) => job.state.toLowerCase() === filters.state.toLowerCase()
//       );
//     }
//     if (selectedLga) {
//       filteredResults = filteredResults.filter(
//         (job) => job.localGovernment?.toLowerCase() === selectedLga.toLowerCase()
//       );
//     }
//     if (selectedCity) {
//       filteredResults = filteredResults.filter(
//         (job) => job.city?.toLowerCase() === selectedCity.toLowerCase()
//       );
//     }

//     setFilteredJobs(filteredResults);
//   };

//   const handleClearFilter = () => {
//     setFilterList([]);
//     setFilteredJobs(allJobs);
//     setSelectedLga(null);
//     setSelectedCity(null);
//     navigate("/jobs");
//   };

//   // Filter from allJobs (not filteredJobs) to avoid progressive narrowing
//   const addFilterElement = (e) => {
//     const selectedElement = e.target.value;
//     const title = e.target.name;

//     if (title === "workOrder") {
//       if (selectedElement === "latest") {
//         setFilteredJobs(
//           [...filteredJobs].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
//         );
//       } else if (selectedElement === "oldest") {
//         setFilteredJobs(
//           [...filteredJobs].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
//         );
//       }
//       return;
//     }

//     const updatedFilteredJobs = allJobs.filter(
//       (eachJob) => eachJob[title]?.toLowerCase() === selectedElement.toLowerCase()
//     );

//     setFilteredJobs(updatedFilteredJobs);
//     setFilterList([...filterList, { title, selectedElement }]);
//   };

//   const handleChange = (e) => {
//     setMainSearchForm({ ...mainSearchForm, [e.target.name]: e.target.value });
//   };

//   const searchByFilter = (e) => {
//     e.preventDefault();
//     applyFilters(allJobs, mainSearchForm);
//     navigate(`/jobs?${qs.stringify(mainSearchForm)}`);
//   };

//   const handleLgaClick = (lga) => {
//     setSelectedLga(lga);
//     setSelectedCity(null);
//     applyFilters(allJobs, { ...mainSearchForm, lga });
//     navigate(`/jobs?${qs.stringify({ ...mainSearchForm, lga })}`);
//   };

//   const handleCityClick = (city) => {
//     setSelectedCity(city);
//     setSelectedLga(null);
//     applyFilters(allJobs, { ...mainSearchForm, city });
//     navigate(`/jobs?${qs.stringify({ ...mainSearchForm, city })}`);
//   };

//   if (loading) return <JobSearchLoader />;

//   return (
//     <div className="min-h-screen bg-gray-100 pt-16 sm:pt-20">
//       <Header darkMode={true} />
//       <div className="container mx-auto p-4">
//         <SearchComponent
//           handleSearch={searchByFilter}
//           handleChange={handleChange}
//           lgas={state ? localGovernments : []}
//           cities={state ? cities : []}
//           handleLgaClick={handleLgaClick}
//           handleCityClick={handleCityClick}
//           state={state}
//           jobCounts={jobCounts}
//         />
//         <div className="flex flex-col lg:flex-row gap-8 mt-8 px-10">
//           <div className="w-full lg:w-2/3">
//             {loading ? (
//               <JobSearchLoader />
//             ) : filteredJobs?.length > 0 ? (
//               filteredJobs.map((eachJob) => (
//                 <JobPostJobPage
//                   key={eachJob._id}
//                   position={eachJob.jobTitle}
//                   companyName={eachJob.employerName}
//                   location={eachJob.state}
//                   salary={eachJob.salary}
//                   jobType={eachJob.workType}
//                   experience={eachJob.experienceLength}
//                   uniqueViewers={eachJob.uniqueViewers}
//                   duration={eachJob.vacancyDuration}
//                   jobId={eachJob._id}
//                   industry={eachJob.industry}
//                   contactMail={eachJob.contactMail}
//                   status="Apply now"
//                   localGovernment={eachJob.localGovernment}
//                   city={eachJob.city}
//                   initialLikeCount={eachJob.likeCount || 0}
//                   initialFollowCount={eachJob.followCount || 0}
//                   isLiked={false}
//                   isFollowing={false}
//                 />
//               ))
//             ) : (
//               <p className="text-center text-gray-600">
//                 No jobs found matching your criteria.
//               </p>
//             )}
//           </div>
//           <div className="w-full lg:w-1/3">
//             <Card className="p-6 mb-8 bg-white shadow-sm rounded-lg">
//               <h2 className="text-xl font-semibold text-gray-800 mb-4">
//                 Jobs in Nigeria
//               </h2>
//               <div className="flex items-center justify-between p-3 bg-gray-50 rounded-md">
//                 <span className="text-gray-600">Filter Applied</span>
//                 <button
//                   onClick={handleClearFilter}
//                   className="text-sm text-orange-500 hover:underline"
//                 >
//                   Clear all
//                 </button>
//               </div>
//               <span className="block mt-2 font-bold text-orange-500">
//                 {filteredJobs?.length} jobs found
//               </span>
//             </Card>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default JobPage;




import { useState, useEffect } from "react";
import SearchComponent from "../../component/SearchComponent";
import JobPostJobPage from "../../component/JobPostJobPage";
import Header from "../../component/Header";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "query-string";
import { useFetchData } from "../../hooks/useFtechData";
import { ALL_JOB } from "../../resources/resource";
import JobSearchLoader from "../../component/utilities/JobSearchLoader";
import Card from "./Crad";
import { getFilteredJobs } from "./data"
function JobPage() {
  const [allJobs, setAllJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  
  const [mainSearchForm, setMainSearchForm] = useState({});
  
  // Salary Filter States
  const [minSalary, setMinSalary] = useState("");
  const [maxSalary, setMaxSalary] = useState("");

  const [selectedLga, setSelectedLga] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [jobCounts, setJobCounts] = useState({ lgas: {}, cities: {} });

  const location = useLocation();
  const navigate = useNavigate();

  const { jobTitle, workType, state, lga, city } = qs.parse(location.search);

  const { data, loading } = useFetchData(ALL_JOB);

  // Extract unique LGAs and Cities for the selected state
  const localGovernments = data
    ? [...new Set(data.filter(job => job.state === state).map(job => job.localGovernment))]
    : [];
    
  const cities = data
    ? [...new Set(data.filter(job => job.state === state).map(job => job.city))]
    : [];

  // Compute job counts for LGAs and Cities
  useEffect(() => {
    if (data && state) {
      const stateJobs = data.filter((job) => job.state === state);
      const lgaCounts = stateJobs.reduce((acc, job) => {
        if (job.localGovernment) acc[job.localGovernment] = (acc[job.localGovernment] || 0) + 1;
        return acc;
      }, {});
      const cityCounts = stateJobs.reduce((acc, job) => {
        if (job.city) acc[job.city] = (acc[job.city] || 0) + 1;
        return acc;
      }, {});
      setJobCounts({ lgas: lgaCounts, cities: cityCounts });
    } else {
      setJobCounts({ lgas: {}, cities: {} });
    }
  }, [data, state]);

  // Initialize allJobs
  useEffect(() => {
    if (data) {
      setAllJobs(data);
      const initialFiltered = getFilteredJobs(data, jobTitle, workType, state); // assuming this function exists
      setFilteredJobs(initialFiltered);
    }
  }, [data, jobTitle, workType, state]);

  // Sync URL params and apply filters
  useEffect(() => {
    if (lga) setSelectedLga(lga);
    if (city) setSelectedCity(city);
    
    applyFilters(allJobs, { 
      jobTitle, 
      workType, 
      state, 
      lga, 
      city, 
      minSalary, 
      maxSalary 
    });
  }, [lga, city, allJobs, jobTitle, workType, state, minSalary, maxSalary]);

  // ====================== MAIN FILTER FUNCTION ======================
  const applyFilters = (jobs, filters) => {
    let filteredResults = [...jobs];

    // Job Title Filter
    if (filters.jobTitle) {
      filteredResults = filteredResults.filter((job) =>
        job.jobTitle?.toLowerCase().includes(filters.jobTitle.toLowerCase())
      );
    }

    // Work Type Filter
    if (filters.workType) {
      filteredResults = filteredResults.filter(
        (job) => job.workType?.toLowerCase() === filters.workType.toLowerCase()
      );
    }

    // State Filter
    if (filters.state) {
      filteredResults = filteredResults.filter(
        (job) => job.state?.toLowerCase() === filters.state.toLowerCase()
      );
    }

    // LGA Filter
    if (selectedLga) {
      filteredResults = filteredResults.filter(
        (job) => job.localGovernment?.toLowerCase() === selectedLga.toLowerCase()
      );
    }

    // City Filter
    if (selectedCity) {
      filteredResults = filteredResults.filter(
        (job) => job.city?.toLowerCase() === selectedCity.toLowerCase()
      );
    }

    // ====================== SALARY FILTER (using 'salary' field) ======================
    const minSal = parseFloat(filters.minSalary);
    const maxSal = parseFloat(filters.maxSalary);

    if (!isNaN(minSal)) {
      filteredResults = filteredResults.filter((job) => {
        const jobSalary = parseFloat(job.salary);   // ← Using 'salary' field
        return !isNaN(jobSalary) && jobSalary >= minSal;
      });
    }

    if (!isNaN(maxSal)) {
      filteredResults = filteredResults.filter((job) => {
        const jobSalary = parseFloat(job.salary);   // ← Using 'salary' field
        return !isNaN(jobSalary) && jobSalary <= maxSal;
      });
    }

    setFilteredJobs(filteredResults);
  };

  const handleClearFilter = () => {
    setMainSearchForm({});
    setMinSalary("");
    setMaxSalary("");
    setSelectedLga(null);
    setSelectedCity(null);
    setFilteredJobs(allJobs);
    navigate("/jobs");
  };

  const handleChange = (e) => {
    setMainSearchForm({ ...mainSearchForm, [e.target.name]: e.target.value });
  };

  // Handle Salary Input Changes (Live Filtering)
  const handleSalaryChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "minSalary") setMinSalary(value);
    if (name === "maxSalary") setMaxSalary(value);

    applyFilters(allJobs, { 
      ...mainSearchForm, 
      state, 
      lga: selectedLga, 
      city: selectedCity, 
      minSalary: name === "minSalary" ? value : minSalary,
      maxSalary: name === "maxSalary" ? value : maxSalary 
    });
  };

  const searchByFilter = (e) => {
    e.preventDefault();
    applyFilters(allJobs, { ...mainSearchForm, minSalary, maxSalary });
    navigate(`/jobs?${qs.stringify({ ...mainSearchForm, minSalary, maxSalary })}`);
  };

  const handleLgaClick = (lga) => {
    setSelectedLga(lga);
    setSelectedCity(null);
    applyFilters(allJobs, { ...mainSearchForm, lga, minSalary, maxSalary });
    navigate(`/jobs?${qs.stringify({ ...mainSearchForm, lga, minSalary, maxSalary })}`);
  };

  const handleCityClick = (city) => {
    setSelectedCity(city);
    setSelectedLga(null);
    applyFilters(allJobs, { ...mainSearchForm, city, minSalary, maxSalary });
    navigate(`/jobs?${qs.stringify({ ...mainSearchForm, city, minSalary, maxSalary })}`);
  };

  if (loading) return <JobSearchLoader />;

  return (
    <div className="min-h-screen bg-gray-100 pt-16 sm:pt-20">
      <Header darkMode={true} />

      <div className="container mx-auto p-4">
        <SearchComponent
          handleSearch={searchByFilter}
          handleChange={handleChange}
          lgas={state ? localGovernments : []}
          cities={state ? cities : []}
          handleLgaClick={handleLgaClick}
          handleCityClick={handleCityClick}
          state={state}
          jobCounts={jobCounts}
        />

        {/* ====================== SALARY FILTER SECTION ====================== */}
        <div className="mt-6 px-10">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <h3 className="font-semibold text-gray-800 mb-4 flex items-center gap-2">
              Filter by Salary Range (₦)
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm text-gray-600 mb-2">Minimum Salary</label>
                <input
                  type="number"
                  name="minSalary"
                  value={minSalary}
                  onChange={handleSalaryChange}
                  placeholder="50000"
                  className="w-full p-4 border border-gray-300 rounded-xl focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-2">Maximum Salary</label>
                <input
                  type="number"
                  name="maxSalary"
                  value={maxSalary}
                  onChange={handleSalaryChange}
                  placeholder="200000"
                  className="w-full p-4 border border-gray-300 rounded-xl focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition"
                />
              </div>
            </div>

            <button
              onClick={handleClearFilter}
              className="mt-5 text-orange-600 hover:text-orange-700 font-medium text-sm flex items-center gap-1"
            >
              Clear All Filters
            </button>
          </div>
        </div>

        {/* Jobs Listing */}
        <div className="flex flex-col lg:flex-row gap-8 mt-10 px-10">
          <div className="w-full lg:w-2/3">
            {filteredJobs?.length > 0 ? (
              filteredJobs.map((eachJob) => (
                <JobPostJobPage
                  key={eachJob._id}
                  position={eachJob.jobTitle}
                  companyName={eachJob.employerName}
                  location={eachJob.state}
                  salary={eachJob.salary}
                  jobType={eachJob.workType}
                  experience={eachJob.experienceLength}
                  uniqueViewers={eachJob.uniqueViewers}
                  duration={eachJob.vacancyDuration}
                  jobId={eachJob._id}
                  industry={eachJob.industry}
                  contactMail={eachJob.contactMail}
                  status="Apply now"
                  localGovernment={eachJob.localGovernment}
                  city={eachJob.city}
                  initialLikeCount={eachJob.likeCount || 0}
                  initialFollowCount={eachJob.followCount || 0}
                  isLiked={false}
                  isFollowing={false}
                />
              ))
            ) : (
              <p className="text-center text-gray-600 py-16 text-lg">
                No jobs found matching your criteria.
              </p>
            )}
          </div>

          <div className="w-full lg:w-1/3">
            <Card className="p-6 mb-8 bg-white shadow-sm rounded-lg">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">Jobs in Nigeria</h2>
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                <span className="text-gray-600">Total Jobs Found</span>
                <span className="font-bold text-2xl text-orange-600">
                  {filteredJobs?.length}
                </span>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobPage;